if ($('body.home').length) {
	let optionsHome = {
		rootMargin: '0px',
		threshold: 0.25
	};
	//VISUEL GALLERIE GEN
	let Competences = $('.competences')
	let containerCompetences = document.querySelectorAll('.container-competences .competences');
	let observerCompetences = new IntersectionObserver(function (entries, observer) {
		entries.forEach((entry) => {
			if (!entry.isIntersecting) {
				return;
			}
			entry.target.classList.add('active')
		});
	}, optionsHome);
	containerCompetences.forEach(containerCompetences => observerCompetences.observe(containerCompetences));
}


